import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement>;

export default (props: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="transparent"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
    {...props}
  >
    <rect width="24" height="24" fill="white"></rect>
    <path d="M7 17L16.8995 7.10051"></path>
    <path d="M7 7.00001L16.8995 16.8995"></path>
  </svg>
);

